import { render } from "./DocumentsSection.vue?vue&type=template&id=98c999a4&scoped=true"
import script from "./DocumentsSection.vue?vue&type=script&lang=js"
export * from "./DocumentsSection.vue?vue&type=script&lang=js"

import "./DocumentsSection.vue?vue&type=style&index=0&id=98c999a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c999a4"]])

export default __exports__